import { render, staticRenderFns } from "./ProducerSap.vue?vue&type=template&id=090a7b26"
import script from "./ProducerSap.vue?vue&type=script&lang=js"
export * from "./ProducerSap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports